/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_MobileInputs */

const en_vc_onl_mobile = /** @type {(inputs: Vc_Onl_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft is made for a mouse or trackpad and a keyboard. On a phone it may be slow or hard to use; a desktop browser works best.`)
};

const zh_vc_onl_mobile = /** @type {(inputs: Vc_Onl_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 是为鼠标、触控板和键盘设计的，在手机上可能很慢或不好操作，建议使用电脑浏览器。`)
};

/**
* | output |
* | --- |
* | "VectorCraft is made for a mouse or trackpad and a keyboard. On a phone it may be slow or hard to use; a desktop browser works best." |
*
* @param {Vc_Onl_MobileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_mobile = /** @type {((inputs?: Vc_Onl_MobileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_MobileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_mobile(inputs)
	return zh_vc_onl_mobile(inputs)
});
export { vc_onl_mobile as "vc.onl.mobile" }